import { cn } from '../lib/utils'

export interface SectionLoadingProps {
  /** What is loading, in plain words: "Loading decisions…". Read aloud, not shown. */
  label: string
  /** How many placeholder lines to hold the space. */
  rows?: number
  className?: string
}

/**
 * A section or list that is still loading: quiet placeholder lines in the
 * shape of the content, announced politely as `label`. The one owner of
 * in-page loading; a whole page loads as PageSkeleton, and a button that is
 * working says so in its own label. Never write a bare "Loading…" line.
 */
export function SectionLoading({ label, rows = 2, className }: SectionLoadingProps) {
  return (
    <div role="status" aria-busy="true" className={cn('space-y-2.5 py-1', className)}>
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className={cn(
            'h-4 animate-pulse rounded-md bg-muted',
            index % 2 === 0 ? 'w-3/5' : 'w-4/5'
          )}
        />
      ))}
    </div>
  )
}
